module.exports = {
    WS_ENDPOINT : process.env.REACT_APP_WS_ENDPOINT || 'https://server.torrz.in'
}